import { render, staticRenderFns } from "./EditInstruction.vue?vue&type=template&id=3ac44e5d"
import script from "./EditInstruction.vue?vue&type=script&lang=js"
export * from "./EditInstruction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports